export default __webpack_public_path__ + "static/media/guide_dev_04.2530bd4f.md";